import PropTypes from 'prop-types';

export default PropTypes.shape({
	createDate: PropTypes.string,
	id: PropTypes.number,
	mediaID: PropTypes.number,
	shareText: PropTypes.string,
	templateID: PropTypes.number,
	templateVersion: PropTypes.number,
	type: PropTypes.number
});